<template>
  <section :class="'-' + toast.type" class="toast">
    <svg class="toast__close" width="16" height="16" @click="close">
      <title>
       Закрыть
      </title>
      
      <use xlink:href="#plus" />
    </svg>

    <div class="toast__countdown-bar">
      <div
        class="toast__countdown-bar-line"
        :style="{ 'animation-duration': (toast.delay || 3000) + 'ms' }"
      />
    </div>

    <div 
      v-if="toast.title" 
      class="toast__title"
    >
      {{ toast.title }}
    </div>
    
    <div 
      v-if="toast.text" 
      class="toast__text"
    >
      {{ toast.text }}
    </div>
  </section>
</template>

<script>
export default {
  props: {
    toast: {
      type: Object,
      required: true
    }
  },

  methods: {
    close: function() {
      this.$store.commit('NOTIFICATION_REMOVE_TOAST', this.toast);
    }
  }
};
</script>

<style lang="scss" src="./toast.scss" />
